import { nantucketConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function NantucketPage() {
  return <CityPageTemplate config={nantucketConfig} />;
}